import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'yaziIsleri';

var dosyaService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    dosyaPath: WsProvider.documentPath,
    path: WsProvider.path,

    dosyaListele(baslangic, limit, dosyaDurumu) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            'data[dosyaDurumu]': dosyaDurumu,
            serviceName: moduleName,
            methodName: 'dosyaListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    tumDosyaListele() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: 'tumDosyaListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    kurumListele(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'kurumListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    evrakDurum() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: 'evrakDurum',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaDurumDegis(dosyaID, durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaID]': dosyaID,
            'data[durum]': durum,
            serviceName: moduleName,
            methodName: 'dosyaAktifPasifYap',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    tarihKontrol(tarih) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[islemTarihi]': tarih,
            serviceName: moduleName,
            methodName: 'tarihKontrol',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    bosDosyaEkle(dosyaDurumu, evrak, evrakKonu, kurum, islemTarihi) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[evrak]': evrak,
            'data[evrakKonu]': evrakKonu,
            'data[kurum]': kurum,
            'data[islemTarihi]': islemTarihi,
            serviceName: moduleName,
            methodName: 'bosDosyaEkle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaEkle(cariID, dosyaDurumu, evrakBaslik, islemTarihi, belge) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[cariID]': cariID,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[evrakBaslik]': evrakBaslik,
            'data[islemTarihi]': islemTarihi,
            belge,
            serviceName: moduleName,
            methodName: 'dosyaEkle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaGuncelle(yaziIsleriID, cariID, konu, belge) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': yaziIsleriID,
            'data[cariID]': cariID,
            'data[konu]': konu,
            [belge ? 'belge' : '']: belge ? belge : '',
            serviceName: moduleName,
            methodName: 'evrakGuncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaGuncelle2(dosyaID, konu) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaID]': dosyaID,
            'data[konu]': konu,
            serviceName: moduleName,
            methodName: 'dosyaGuncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaDetay(evrakID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yaziIsleriID]': evrakID,
            serviceName: moduleName,
            methodName: 'evrakDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaSil(yaziIsleriID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[id]': yaziIsleriID,
            serviceName: moduleName,
            methodName: 'evrakSil',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },

    dosyaArama(kurumAdi, konu, kayitKodu, dosyaDurumu, islemTarihi, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[kurumAdi]': kurumAdi,
            'data[konu]': konu,
            'data[kayitKodu]': kayitKodu,
            'data[dosyaDurumu]': dosyaDurumu,
            'data[islemTarihi]': islemTarihi,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'dosyaArama',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
};

export default dosyaService;
